namespace TabAurous.Retail {
    export interface PosSalesPromoRow {
        TransPromoId?: number;
        TransId?: number;
        PromoId?: number;
        ProductTypeId?: number;
        TotalAmount?: number;
        PromoPer?: number;
        PromoAmount?: number;
        ProductTypeName?: string;
        PromoCode?: string;
        PromoName?: string;
    }

    export namespace PosSalesPromoRow {
        export const idProperty = 'TransPromoId';
        export const localTextPrefix = 'Retail.PosSalesPromo';
        export const deletePermission = 'Retail:POSSales:Delete';
        export const insertPermission = 'Retail:POSSales:Add';
        export const readPermission = '*';
        export const updatePermission = 'Retail:POSSales:Edit';

        export declare const enum Fields {
            TransPromoId = "TransPromoId",
            TransId = "TransId",
            PromoId = "PromoId",
            ProductTypeId = "ProductTypeId",
            TotalAmount = "TotalAmount",
            PromoPer = "PromoPer",
            PromoAmount = "PromoAmount",
            ProductTypeName = "ProductTypeName",
            PromoCode = "PromoCode",
            PromoName = "PromoName"
        }
    }
}
